import React, { ReactNode } from "react";
import { ChakraProvider as ChakraUIProvider } from "@chakra-ui/react";

import theme from "../styles/theme";

interface IChakraProviderProps {
  children: ReactNode;
}

function ChakraProvider(props: IChakraProviderProps): React.JSX.Element {
  return (
    <ChakraUIProvider theme={theme}>
      {props.children}
    </ChakraUIProvider>
  );
}

export default ChakraProvider;